import { render } from "./RecallDetailsModal.vue?vue&type=template&id=42f4c08a"
import script from "./RecallDetailsModal.vue?vue&type=script&lang=js"
export * from "./RecallDetailsModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__